import { useGetDealerBrandsQuery } from '@api/customer.api';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  LoadingSkeleton,
  WarrantyBrandSelect,
  WarrantySerialNumber,
  useWarrantyClaimContext,
} from '@components';
import { Box } from '@mui/material';
import { t } from '@translations';

export const WarrantyBrandsForm = () => {
  const { form } = useWarrantyClaimContext();
  const { isLoading: isBrandsLoading } = useGetDealerBrandsQuery();
  const selectedBrand = form.watch('brand');

  return (
    <Box
      display='flex'
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
      }}
    >
      {isBrandsLoading ? (
        <LoadingSkeleton
          variant='rectangular'
          height={44}
          sx={{
            width: {
              xs: '100%',
              sm: 300,
            },
          }}
        />
      ) : (
        <WarrantyBrandSelect
          sx={{
            maxWidth: {
              xs: '100%',
              sm: 300,
            },
          }}
        />
      )}
      {isBrandsLoading ? (
        <LoadingSkeleton
          variant='rectangular'
          height={44}
          sx={{
            ml: { sm: 4 },
            width: {
              xs: '100%',
              sm: 300,
            },
          }}
        />
      ) : (
        selectedBrand !== 'Others' && (
          <Box sx={{ ml: { sm: 4 }, mt: { xs: 2, sm: 0 } }}>
            <WarrantySerialNumber
              placeholder={t(TextCodes.Warranty.Block.SerialNumber, {
                example: '(F.eks: MBFF-123456)',
              })}
              shouldValidateSerial={selectedBrand === 'Honda' || selectedBrand === 'Cramer'}
              sx={{
                width: { xs: '100%', sm: 300 },
              }}
              errorText={t(TextCodes.Warranty.Block.SerialNumberIncorrect)}
            />
          </Box>
        )
      )}
    </Box>
  );
};
